/* eslint-disable @typescript-eslint/no-non-null-assertion */
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FormControl, IconButton, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import React from "react";
import { Field, Form as FinalForm } from "react-final-form";
import { useTranslation } from "react-i18next";

import { Label } from "../home/Home.sc";
import { Category, ExerciseId, Setting } from "../types";
import ExerciseSelect from "./ExerciseSelect";
import { useSettings } from "./useSettings";
import { YesNoRadio } from "./YesNoRadio";

export interface ExerciseSelectionFormValues {
    discreet: "yes" | "no";
    favourite: "yes" | "no";
    categories: Category[];
}

interface Props {
    favourites: ReadonlyArray<ExerciseId>;
    onSubmit: (values: ExerciseSelectionFormValues) => void;
    buttons: (values: ExerciseSelectionFormValues) => React.ReactNode;
}

// TODO: When no exercises set value to "no"

const ExerciseSelectionForm = ({ favourites, onSubmit, buttons }: Props) => {
    const { t } = useTranslation();
    const { setting, initialValues, handleChange, selectOptions } = useSettings();

    return (
        <FinalForm
            onSubmit={onSubmit}
            initialValues={initialValues}
            render={({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                    <h4>{t("form_headline")}</h4>

                    <Label>
                        <Typography style={{ marginRight: 8 }}>{t("form_saved_setting")}</Typography>
                        <Tooltip
                            disableFocusListener
                            title={t("tooltip_settings")}
                            enterTouchDelay={0}
                            leaveTouchDelay={5000}
                            sx={{ m: 1 }}
                            placement="top"
                            arrow
                        >
                            <IconButton style={{ padding: 0, margin: 0 }}>
                                <InfoOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Label>
                    <FormControl variant="standard" sx={{ minWidth: 200 }} style={{ marginBottom: 5 }}>
                        <Field
                            name="setting"
                            component={() =>
                                selectOptions.length === 0 ? (
                                    <Typography style={{ color: "rgba(0, 0, 0, 0.26)" }}>{t("no_settings_available")}</Typography>
                                ) : (
                                    <Select value={setting} onChange={handleChange} disabled={selectOptions.length === 0}>
                                        {selectOptions.map((setting: Setting, index: number) => (
                                            <MenuItem value={index} key={setting.name}>
                                                {setting.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )
                            }
                        />
                    </FormControl>

                    <Label>
                        <Typography style={{ marginRight: 8 }}>{t("form_exercises")}</Typography>
                        <Tooltip
                            disableFocusListener
                            title={t("tooltip_categories")}
                            enterTouchDelay={0}
                            leaveTouchDelay={5000}
                            sx={{ m: 1 }}
                            placement="top"
                            arrow
                        >
                            <IconButton style={{ padding: 0, margin: 0 }}>
                                <InfoOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Label>
                    <Field name="categories" component={ExerciseSelect} />
                    <YesNoRadio label={t("form_discreet")} tooltip={t("tooltip_discreet")} name="discreet" />
                    <YesNoRadio label={t("form_favourites")} tooltip={t("tooltip_favourites")} name="favourite" disabled={favourites.length === 0} />
                    {buttons(values)}
                </form>
            )}
        />
    );
};

export default ExerciseSelectionForm;
